import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class CustomerUser {
    create(data) {
        return BaseService.post(APIPath.customerUser, data)
    }

    getById(id) {
        return BaseService.get(`${APIPath.customerUserById}${id}`)
    }

    getByUserId(userId) {
        return BaseService.get(`${APIPath.customerUserByUserId}${userId}`)
    }

    getByCompany(companyId) {
        return BaseService.get(`${APIPath.customerUserByCompany}${companyId}`)
    }

    update(data) {
        return BaseService.post(APIPath.customerUserUpdate, data)
    }

    remove(id) {
        return BaseService.post(`${APIPath.customerUserDelete}${id}`)
    }

    // New APIs from Postman collection
    getList(companyId, customerId) {
        return BaseService.get(`${APIPath.customerUserList}/${companyId}/${customerId}`)
    }

    sync(data) {
        return BaseService.post(APIPath.customerUserSync, data)
    }

    // Department role model (opted-in companies): { Items: [{ CustomerId, CustomerName, IsReadOnly, IsOwner, Relation }] }
    getDepartmentRelation(userId) {
        return BaseService.get(`${APIPath.departmentRelation}?userId=${userId}`)
    }

    // { UserId, Items: [{ CustomerId, Relation: 'own' | 'audit' | 'default' }] } - company admins only
    saveDepartmentRelation(data) {
        return BaseService.postExact(APIPath.departmentRelation, data)
    }
}

const CustomerUserService = new CustomerUser()
Object.freeze(CustomerUserService)
export { CustomerUserService }
